import * as CommonActions from '../actions/common.action';
import {
  ICommonListItemsResponse,
  IReportFiltersItems,
} from '../../shared/interfaces/static.interface';

interface ICommonState {
  /* eslint-disable camelcase */
  base_of_assignments: Array<ICommonListItemsResponse>;
  company: Array<ICommonListItemsResponse>;
  filters: Array<IReportFiltersItems>;
  signatories: Array<string>;
  params: {
    province?: string;
    step?: string;
  };
}

const initialState: ICommonState = {
  base_of_assignments: [],
  company: [],
  filters: [],
  signatories: [],
  params: {
    province: '',
    step: '',
  },
};

const reducer = (state = initialState, action: { type: string; payload: any }) => {
  const { type, payload } = action;

  switch (type) {
    case CommonActions.COMMON_FETCH_SIGNATORY:
      return {
        ...state,
        params: payload,
      };

    case CommonActions.COMMON_FETCH_SIGNATORY_SUCCESS:
      return {
        ...state,
        signatories: payload,
      };

    case CommonActions.COMMON_FETCH_SIGNATORY_ERROR:
      return {
        ...state,
      };

    case CommonActions.COMMON_FETCH_REPORT_FILTERS:
      return {
        ...state,
      };

    case CommonActions.COMMON_FETCH_REPORT_FILTERS_SUCCESS:
      return {
        ...state,
        filters: payload,
      };

    case CommonActions.COMMON_FETCH_REPORT_FILTERS_ERROR:
      return {
        ...state,
      };

    case CommonActions.COMMON_FETCH_AFFILIATES:
      return {
        ...state,
      };

    case CommonActions.COMMON_FETCH_AFFILIATES_SUCCESS:
      return {
        ...state,
        company: payload,
      };

    case CommonActions.COMMON_FETCH_AFFILIATES_ERROR:
      return {
        ...state,
      };

    case CommonActions.COMMON_FETCH_BASE_OF_ASSIGNMENTS:
      return {
        ...state,
      };

    case CommonActions.COMMON_FETCH_BASE_OF_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        base_of_assignments: payload,
      };

    case CommonActions.COMMON_FETCH_BASE_OF_ASSIGNMENTS_ERROR:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default reducer;
